import React, { useState } from 'react';
import styles from './style.module.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { useAuth } from '../../../configs/context/AuthContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Button, InputField } from '../../elements';

export default function LoginPopup({ setShowLoginModal }) {
  const { login } = useAuth();
  const [usernameInput, setUsernameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');

  const loginSource = axios.CancelToken.source();

  const handleLogin = async (e) => {
    e.preventDefault();

    const userData = {
      username: usernameInput,
      password: passwordInput,
    };

    await login(userData, loginSource, setShowLoginModal);
  };

  return (
    <div className={styles.root}>
      <div className={styles.popupWrapper}>
        <div className={styles.leftImage}></div>
        <div className={styles.rightContent}>
          <div className={styles.contentWrapper}>
            <h2>LOGIN</h2>
            <form onSubmit={handleLogin}>
              <InputField
                name="username"
                // type="email"
                type="text"
                value={usernameInput}
                setInputValue={setUsernameInput}
                placeholder="Nomor Ponsel atau Email"
                loginForm
                className={styles.inputForm}
              />
              <InputField
                name="password"
                type="password"
                value={passwordInput}
                setInputValue={setPasswordInput}
                placeholder="Kata Sandi"
                loginForm
                className={styles.inputForm}
              />
              <Button type="submit" label="Masuk" color="primary" blockBtn />
            </form>
            <hr className={styles.login} />
            <div className={styles.manageAccount}>
              <div className={styles.left}>
                <p>Don't have an account?</p>
                <p>Lupa kata sandi?</p>
              </div>
              <div className={styles.right}>
                <Link to="/" onClick={() => setShowLoginModal(false)}>
                  Register Your Account
                </Link>
                <Link to="/" onClick={() => setShowLoginModal(false)}>
                  Reset Kata Sandi
                </Link>
              </div>
            </div>
          </div>
          <FontAwesomeIcon
            icon={faCircleXmark}
            className={styles.exitIcon}
            onClick={() => setShowLoginModal(false)}
          />
        </div>
      </div>
    </div>
  );
}
